<app-efemerides (efemeridesVacias)="onEfemeridesVacias($event)"></app-efemerides>
<app-banner *ngIf="mostrarBanner"></app-banner>
<app-fotografias></app-fotografias>
<app-portadas></app-portadas>
